
import React , { useState , useMemo , startTransition , useEffect}  from "react";
import {
  LineChart, Line, XAxis, YAxis,
  Tooltip, CartesianGrid, Bar, BarChart,
  ResponsiveContainer , ComposedChart
} from "recharts";
import Loaderanimation from 'components/ui/loaderanimation';

import {
 useCompanyHistoricalData , 
 useCompanyChartotherData
} from 'data/company';

const RANGE_MAP = {
  "1M": 30,
  "6M": 180,
  "1Y": 365,
  "3Y": 1095,
  "5Y": 1825,
  "10Y": 3650,
  "MAX": Infinity
};

const INDICATOR_COLORS = {
  price: "#0000A3",
  volume: "#B8B8FF",
  dma50: "#16a34a",
  dma100: "#f59e0b",
  dma200: "#ef4444",
};

const CustomTooltip = ({ active, payload, label, indicators }) => {
  if (!active || !payload?.length) return null;

  const getValue = (key) => {
    const val = payload.find(p => p.dataKey === key)?.value;
    const num = Number(val);
    return isNaN(num) ? null : num;
  };

  const price = getValue("close_price");
  const volume = getValue("volume");
  const dma50 = getValue("DMA50");
  const dma100 = getValue("DMA100");
  const dma200 = getValue("DMA200");

  return (
    <div className="rounded-md border bg-white p-2 text-sm shadow">
      <div className="mb-1 font-medium">
        {new Date(label).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </div>

      {price !== null && (
        <div className="flex justify-between">
          <span>Price</span>
          <span className="font-semibold">₹{price}</span>
        </div>
      )}

      {volume !== null && (
        <div className="flex justify-between">
          <span>Volume</span>
          <span>{(volume / 1e6).toFixed(2)}M</span>
        </div>
      )}

      {/* DMA 50 */}
      {indicators?.dma50 && dma50 !== null && (
        <div className="flex justify-between">
          <span>50 DMA</span>
          <span style={{ color: "#16a34a" }}>₹{dma50.toFixed(2)}</span>
        </div>
      )}

      {/* DMA 100 */}
      {indicators?.dma100 && dma100 !== null && (
        <div className="flex justify-between">
          <span>100 DMA</span>
          <span style={{ color: "#f59e0b" }}>₹{dma100.toFixed(2)}</span>
        </div>
      )}

      {/* DMA 200 */}
      {indicators?.dma200 && dma200 !== null && (
        <div className="flex justify-between">
          <span>200 DMA</span>
          <span style={{ color: "#ef4444" }}>₹{dma200.toFixed(2)}</span>
        </div>
      )}
    </div>
  );
};


const CustomTooltipPE = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  const getValue = (key) => {
    const val = payload.find(p => p.dataKey === key)?.value;
    const num = Number(val);
    return isNaN(num) ? null : num;
  };

  const pe = getValue("pe");
  const eps = getValue("eps");

  return (
    <div className="rounded-md border bg-white p-2 text-sm shadow">
      {/* Date */}
      <div className="mb-1 font-medium">
        {new Date(label).toLocaleDateString("en-IN", {
          year: "numeric",
        })}
      </div>

      {/* PE */}
      {pe !== null && (
        <div className="flex justify-between gap-4">
          <span className="text-slate-600">P/E</span>
          <span style={{ color: "#0000A3" }}>
            {pe.toFixed(2)}
          </span>
        </div>
      )}

      {/* EPS */}
      {eps !== null && (
        <div className="flex justify-between gap-4">
          <span className="text-slate-600">EPS</span>
          <span className="text-indigo-600 font-medium">
            ₹{eps.toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
};



function downSampleData(data, maxPoints = 400) {
  if (!Array.isArray(data) || data.length <= maxPoints) return data;

  const step = Math.ceil(data.length / maxPoints);
  return data.filter((_, index) => index % step === 0);
}




export default function StockChartSection({companyinfo}) {

const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [range , setRange] = useState('1Y');
  const [viewtype , setViewtype] = useState('Price');

  const ranges = ["1M", "6M", "1Y", "3Y", "5Y", "10Y", "MAX"];
  const dataoption = ["Price", "PE ratio"];

  const {
        historicaldata,
        isLoading: loading,
        error:errorindicescomp,
        isFetching:ldnfetching,

      } = useCompanyHistoricalData(companyinfo?.id);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
  // function get other data 

  const {
        chartdataOther,
        isLoading: loadingchro,
        error:errorindicescompchro,
        isFetching:chrofetching,

      } = useCompanyChartotherData(companyinfo?.id);

      console.log("chartdataOther",chartdataOther);

    const filteredData = useMemo(
    () => filterByRange(historicaldata, range),
    [historicaldata, range ]
  );


  const filteredDatacharoth = useMemo(
    () => filterByRangeOther(chartdataOther, range),
    [chartdataOther, range]
  );

  
function filterByRange(data, range) {
   if (!Array.isArray(data)) {
    console.warn("filterByRangeOther expected array, got:", data);
    return [];
  }

  if (range === "MAX") return data;
  if(loading || loadingchro){

  }else{
  const days = RANGE_MAP[range];
  const endDate = new Date(data[data.length - 1]?.trade_date);
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - days);


   return data?.filter(d => {
    if (!d?.trade_date) return false;
    return new Date(d.trade_date) >= startDate;
  });
  }
}



function filterByRangeOther(data = [], range) {
   if (!Array.isArray(data)) {
    console.warn("filterByRangeOther expected array, got:", data);
    return [];
  }

  
  if (range === "MAX") return data;
  if(loading){

  }else{
  const days = RANGE_MAP[range];
  const endDate = new Date(data[data.length - 1]?.fiscal_year);
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - days);

 return data?.filter(d => {
    if (!d?.fiscal_year) return false;
    return new Date(d.fiscal_year) >= startDate;
  });
  }
}
  
const optimizedHistorical = useMemo(() => {
  const filtered = filterByRange(historicaldata, range, "trade_date");

  if (range === "3Y" || range === "5Y" || range === "10Y" || range === "MAX") {
    return downSampleData(filtered);
  }

  return filtered;
}, [historicaldata, range]);

const formatXAxisDate = (date, range) => {
  const d = new Date(date);

  if (range === "3Y" || range === "5Y" || range === "10Y" || range === "MAX") {
    return d.toLocaleDateString("en-IN", {
      month: "short",
      year: "2-digit",
    });
  }

  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
  });
};
const isChartLoading =
  loading ||
  ldnfetching ||
  loadingchro ||
  chrofetching;

  const hasData =
  Array.isArray(optimizedHistorical) &&
  optimizedHistorical.length > 0;

  const hasDataPE = Array.isArray(filteredDatacharoth) &&
  filteredDatacharoth.length > 0;


  function hasDataForRange(data, range, dateKey = "trade_date") {
  if (!Array.isArray(data) || data.length === 0) return false;

  if (range === "MAX") return true;

  const days = RANGE_MAP[range];
  const endDate = new Date(data[data.length - 1]?.[dateKey]);
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - days);

  return data.some(d => {
    if (!d?.[dateKey]) return false;
    return new Date(d[dateKey]) >= startDate;
  });
}

function getFilteredDataByRange(data, range, dateKey) {
  if (!Array.isArray(data) || data.length === 0) return [];

  if (range === "MAX") return data;

  const days = RANGE_MAP[range];
  const endDate = new Date(data[data.length - 1]?.[dateKey]);
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - days);

  return data.filter(d =>
    d?.[dateKey] && new Date(d[dateKey]) >= startDate
  );
}



const availableRanges = useMemo(() => {
  const sourceData =
    viewtype === "Price"
      ? historicaldata
      : chartdataOther;

  const dateKey =
    viewtype === "Price"
      ? "trade_date"
      : "fiscal_year";

  if (!Array.isArray(sourceData) || sourceData.length === 0)
    return [];

  let previousLength = 0;

  return ranges.filter(range => {
    const filtered = getFilteredDataByRange(
      sourceData,
      range,
      dateKey
    );

    const currentLength = filtered.length;

    // Hide if no change in data size
    if (currentLength === previousLength) {
      return false;
    }

    previousLength = currentLength;
    return true;
  });
}, [historicaldata, chartdataOther, viewtype]);

useEffect(() => {
  if (!availableRanges.length) return;

  // If current range is still valid, keep it
  if (availableRanges.includes(range)) return;

  // 1️⃣ Prefer 1Y if exists
  if (availableRanges.includes("1Y")) {
    setRange("1Y");
    return;
  }

  // 2️⃣ Otherwise pick middle range
  const middleIndex = Math.floor(availableRanges.length / 2);
  setRange(availableRanges[middleIndex]);
}, [availableRanges]);


const [indicators, setIndicators] = useState({
  price: true,
  volume: true,
  dma50: false,
  dma100: false,
  dma200: false,
});

const toggleIndicator = (key) => {
  setIndicators(prev => ({
    ...prev,
    [key]: !prev[key]
  }));
};

const formatXAxisDateResponsive = (date, range) => {
  const d = new Date(date);

  if (isMobile) {
    // Short format for mobile
    if (range === "1M" || range === "3M")
      return `${d.getDate()}/${d.getMonth() + 1}`;

    if (range === "6M" || range === "1Y")
      return `${d.toLocaleString("default", { month: "short" })}`;

    return d.getFullYear();
  }

  // Desktop format (full)
  return formatXAxisDate(date, range);
};

  return (
      <section className="relative bg-white shadow-md z-6 rounded-xl p-5 w-full"  >
    <div className="flex flex-col md:flex-row justify-start md:justify-between mb-5">
    <div className="flex  ghasDataPEap-2 border-[1px] w-fit my-4">
   {availableRanges.map(r => (
      <button
        key={r}
        onClick={() => {
        startTransition(() => {
          setRange(r);
        });
      }}
        className={`${range === r ? "active text-accent" : ""}  p-2  text-sm `}
      >
        {r}
      </button>
    ))}
  </div>
  <div  className="flex  gap-2 border-[1px] w-fit my-0 mb-1 md:my-4">
    {dataoption.map(r => (
      <button
        key={r}
        onClick={() => setViewtype(r)}
        className={`${viewtype === r ? "active text-accent" : ""}  p-2  text-sm `}
      >
        {r}
      </button>
    ))}
  </div>
  </div>
  {isChartLoading &&
    <div className="absolute inset-0 bg-white/50 backdrop-blur-sm flex items-center justify-center z-10 transition-opacity duration-300">
      <Loaderanimation count={10} /></div>
 }
    <>
    {viewtype == 'Price'?
    <>{!hasData ? (
      <div className="w-full h-[350px] flex items-center justify-center text-gray-400 text-sm">
        No Data Available Yet , please check again later.
      </div>
    ) : (
     <ResponsiveContainer width="100%"  height={isMobile ? 350 : 400}  >
        <ComposedChart data={optimizedHistorical} 
         margin={{
	    top: 10,
	    right: isMobile ? 0 : 30,
	    left: isMobile ? 0 : 20,
	    bottom: 10
	  }}
        >
          {/*<XAxis dataKey="trade_date"
            interval={Math.floor(optimizedHistorical?.length / 6)}
            tickFormatter={(d) => formatXAxisDate(d, range)}
        tick={{ fontSize: 12, fill: "#64748b" }}
          />*/}
          <XAxis
	  dataKey="trade_date"
	  interval={isMobile ? Math.floor(optimizedHistorical?.length / 3) : Math.floor(optimizedHistorical?.length / 6)}
	  tickFormatter={(d) => formatXAxisDateResponsive(d, range)}
	  tick={{
	    fontSize: isMobile ? 10 : 12,
	    fill: "#64748b"
	  }}
	  angle={isMobile ? -30 : 0}
	  textAnchor={isMobile ? "end" : "middle"}
	  height={isMobile ? 50 : 30}
	/>
          <YAxis yAxisId="price" orientation="right" label={!isMobile
    ? {
        value: "Price (₹)",
        angle: -90,
        position: "insideRight",
      }
    : null} 
    width={isMobile ? 30 : 60}
      tickCount={isMobile ? 3 : 6}
      domain={['dataMin - 1', 'dataMax + 1']}
      tickFormatter={(v) =>{
      if (v >= 1e7) return `₹${(v / 1e7).toFixed(1)}Cr`;
	  if (v >= 1e5) return `₹${(v / 1e5).toFixed(1)}L`;
	  if (v >= 1e3) return `₹${(v / 1e3).toFixed(1)}K`;
	  return `₹${v}`;
      }}
        tick={{fontSize: isMobile ? 9 : 12, fill: "#64748b" }}
      />
          <YAxis yAxisId="volume" label={!isMobile ? {
        value: "Volume",
        angle: 90,
        position: "insideLeft",
      } : null }  
      width={isMobile ? 30 : 60}
     tickCount={isMobile ? 3 : 6}
  tickFormatter={(v) =>
    v >= 1e7 ? `${(v / 1e7).toFixed(1)}Cr` :
    v >= 1e5 ? `${(v / 1e5).toFixed(1)}L` :
    v
  }
    tick={{ fontSize: isMobile ? 9 : 12, fill: "#64748b" }}
      
      />
         <Tooltip content={<CustomTooltip indicators={indicators} />} />
    
          {indicators.price && (
	  <Line
	    yAxisId="price"
	    dataKey="close_price"
	    type="monotone"
	    dot={false}
	    strokeWidth={2}
	    stroke="#0000A3"
	  />
	)}
          {/* Volume */}
         {indicators.volume && (
	  <Bar
	    yAxisId="volume"
	    dataKey="volume"
	    barSize={40}
	    fill="#B8B8FF"
	  />
	)}
	
	{indicators.dma50 && (
  <Line
    yAxisId="price"
    dataKey="DMA50"
    type="monotone"
    dot={false}
    strokeWidth={1.5}
    stroke="#16a34a"
  />
)}

{indicators.dma100 && (
  <Line
    yAxisId="price"
    dataKey="DMA100"
    type="monotone"
    dot={false}
    strokeWidth={1.5}
    stroke="#f59e0b"
  />
)}

{indicators.dma200 && (
  <Line
    yAxisId="price"
    dataKey="DMA200"
    type="monotone"
    dot={false}
    strokeWidth={1.5}
    stroke="#ef4444"
  />
)}
        </ComposedChart>
      </ResponsiveContainer>
    )
    }
    <div className="flex flex-wrap gap-4 mt-4 text-sm justify-center">
	  {[
	    { key: "price", label: "Price" },
	    { key: "volume", label: "Volume" },
	    { key: "dma50", label: "50 DMA" },
	    { key: "dma100", label: "100 DMA" },
	    { key: "dma200", label: "200 DMA" },
	  ].map(item => (
	    <label key={item.key} className="flex items-center gap-2 cursor-pointer">
	      <input
		  type="checkbox"
		  checked={indicators[item.key]}
		  onChange={() => toggleIndicator(item.key)}
    className="h-4 w-4 cursor-pointer appearance-none border rounded checked:bg-current"
		  style={{
		    color: INDICATOR_COLORS[item.key],
		  }}
		/>
	      {item.label}
	    </label>
	  ))}
	</div>
    </>
      : 
      <>{!hasDataPE ? (
      <div className="w-full h-[350px] flex items-center justify-center text-gray-400 text-sm">
        No Data Available Yet , please check again later.
      </div>
    ) : (
       <ResponsiveContainer width="100%" height={350}>
        <ComposedChart data={filteredDatacharoth}>
          <XAxis dataKey="fiscal_year"
            interval={Math.floor(filteredDatacharoth?.length / 6)}
            tickFormatter={(d) => formatXAxisDate(d, range)}
        tick={{ fontSize: 12, fill: "#64748b" }}
          />
          <YAxis yAxisId="pe" orientation="right" label={{
        value: "P/E",
        angle: -90,
        position: "insideRight",
      }} 
      tickCount={5}
      domain={['dataMin - 1', 'dataMax + 1']}
      tickFormatter={(v) => `₹${v.toFixed(0)}`}
        tick={{ fontSize: 12, fill: "#64748b" }}
      />
          <YAxis yAxisId="eps" label={{
        value: "EPS (₹)",
        angle: 90,
        position: "insideLeft",
      }}  
      tickCount={6}
  tickFormatter={(v) =>
    v >= 1e7 ? `${(v / 1e7).toFixed(1)}Cr` :
    v >= 1e5 ? `${(v / 1e5).toFixed(1)}L` :
    v
  }
    tick={{ fontSize: 12, fill: "#64748b" }}
      
      />
      <Tooltip content={<CustomTooltipPE />} />
         
          {/* Price */}
          <Line
            yAxisId="pe"
            dataKey="pe"
            type="monotone"
            dot={false}
            strokeWidth={2}
            stroke="#0000A3"
          />
          {/* Volume */}
          <Bar
            yAxisId="eps"
            dataKey="eps"
            barSize={40}
            fill="#B8B8FF"
          />
        </ComposedChart>
      </ResponsiveContainer>)
      }
      </>
    }
      </>
      
    </section>
  );
}
